import { render, staticRenderFns } from "./accountTypeSetForm.vue?vue&type=template&id=d2bc400a"
import script from "./accountTypeSetForm.vue?vue&type=script&lang=js"
export * from "./accountTypeSetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports